// features/services/services.data.js
export const services = [
  {
    id: 1,
    title: "გათბობის მონტაჟი",
    description: "სრული გათბობის სისტემის დაყენება",
    details:
      "ვაკეთებთ გათბობის სისტემის სრულ პროექტირებას და მონტაჟს: ქვაბის შერჩევა, რადიატორების სწორი განთავსება, მილგაყვანილობა, ტესტირება და სისტემის დაბალანსება. დასრულების შემდეგ გაძლევთ უსაფრთხო ექსპლუატაციის რეკომენდაციებს.",
    icon: "🔥",
  },
  {
    id: 2,
    title: "სანტექნიკის შეკეთება",
    description: "გაჟონვის და დაზიანების სწრაფი მოგვარება",
    details:
      "ავარიულ შემთხვევებში სწრაფად გამოვდივართ ადგილზე და ვაგვარებთ პრობლემას მინიმალური დაზიანებით: გაჟონვა, წნევის ვარდნა, ნიჟარის/უნიტაზის პრობლემები, მილების დაზიანება და არმატურის შეცვლა. ვმუშაობთ სუფთად და შეთანხმებული ფასით.",
    icon: "🔧",
  },
  {
    id: 3,
    title: "ქვაბის დიაგნოსტიკა",
    description: "ქვაბის შემოწმება და გამართვა",
    details:
      "ვაკეთებთ ქვაბის კომპლექსურ დიაგნოსტიკას: Error კოდების ინტერპრეტაცია, სენსორების და ტუმბოს შემოწმება, წვის პარამეტრების კორექტირება, უსაფრთხოების ტესტები და პროფილაქტიკური მომსახურება, რომ დაზოგო ენერგია და აირიდო მოულოდნელი გაჩერება.",
    icon: "⚙️",
  },
  {
    id: 4,
    title: "რადიატორის მონტაჟი/გადატანა",
    description: "რადიატორების სწორად დაყენება და გადაკეთება",
    details:
      "ვაყენებთ ახალ რადიატორებს, ვცვლით ძველებს და ვაკეთებთ გადატანას ინტერიერის მიხედვით. სამუშაოში შედის სამაგრების მონტაჟი, მილების მიყვანა, ჰერმეტულობის შემოწმება და სისტემის საბოლოო ტესტირება.",
    icon: "♨️",
  },
  {
    id: 5,
    title: "წყლის ტუმბოს მომსახურება",
    description: "ტუმბოს დიაგნოსტიკა და ჩანაცვლება",
    details:
      "ვადგენთ ტუმბოს წარმადობის პრობლემებს, ხმაურს, წნევის ვარდნას და ავტომატიკის გაუმართაობას. საჭიროების შემთხვევაში ვცვლით ტუმბოს და ვმართავთ სისტემას სტაბილური მუშაობისთვის.",
    icon: "💧",
  },
  {
    id: 7,
    title: "წყლის გამაცხელებლის სერვისი",
    description: "ბოილერის პროფილაქტიკა და რემონტი",
    details:
      "ვაკეთებთ ბოილერის წმენდას, ანოდის შემოწმებას, თერმოსტატის დიაგნოსტიკას და გათბობის ელემენტის ჩანაცვლებას. ეს აუმჯობესებს მუშაობას და ახანგრძლივებს მოწყობილობის სიცოცხლეს.",
    icon: "🚿",
  },
  {
    id: 9,
    title: "იატაკქვეშა გათბობის გამართვა",
    description: "სისტემის დიაგნოსტიკა და ბალანსირება",
    details:
      "ვადგენთ იატაკქვეშა გათბობის ზონურ პრობლემებს, ვამოწმებთ კოლექტორს, თერმოსტატებს და ცირკულაციას. საჭიროების მიხედვით ვაკეთებთ ბალანსირებას, რომ გათბობა თანაბრად გადანაწილდეს.",
    icon: "🌡️",
  },
];
